import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"font-size":"20px"}
}
const _hoisted_3 = {
  key: 0,
  class: "spin"
}
const _hoisted_4 = { style: {"white-space":"pre-line"} }
const _hoisted_5 = { class: "ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    (_ctx.profession)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                          _cache[1] || (_cache[1] = _createTextVNode(" Segments related to ")),
                          _createElementVNode("b", null, _toDisplayString(_ctx.profession.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_2, " Segments "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      fullscreen: true,
      style: {"min-height":"150px"}
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ion_spinner)
            ]))
          : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profession.relatedSegments, (s, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    lines: "full",
                    key: s.id,
                    style: {"--min-height":"55px"},
                    button: "",
                    detail: "",
                    onClick: ($event: any) => (_ctx.openSegmentModal(s))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", _hoisted_4, _toDisplayString(idx+1) + ". " + _toDisplayString(s.name), 1),
                          _createElementVNode("p", null, "segment of the " + _toDisplayString(s.sector.name) + " sector", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                _withDirectives(_createElementVNode("div", _hoisted_5, _cache[2] || (_cache[2] = [
                  _createElementVNode("p", null, "No information available", -1)
                ]), 512), [
                  [_vShow, _ctx.profession.relatedSegments.length == 0]
                ])
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 64))
}